import api from "./axios";

// Only responses made entirely from seeded lookups belong here. Definitions
// containing users, roles, or allowed statuses must keep their normal refreshes.
const seededDefinitionEndpoints = new Set([
    "Notes/definitions",
    "Applications/FaceSheet/definitions",
    "Applications/CostEstimate/definitions",
    "Housing/definitions",
    "Applications/PDS/definitions",
    "Applications/TransitionPlan/Needs/definitions",
    "Applications/TransitionPlan/Services/definitions",
    "Applications/TransitionPlan/Providers/definitions"
]);

export const seededDefinitionQueryOptions = (url, params = null) => {
    if (!seededDefinitionEndpoints.has(url)) {
        return null;
    }

    // Older callers add a timestamp. Ignore that cache-buster, but never reuse
    // an unfiltered response for a request containing actual query parameters.
    if (params && Object.keys(params).some((key) => key !== "timestamp")) {
        return null;
    }

    return {
        queryKey: ["definitions", url],
        queryFn: ({ signal }) => api.get(url, { signal }).then((response) => response.data),
        staleTime: Infinity,
        gcTime: Infinity
    };
};
